var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ach-choice-dialog" }, [
    _c("header", { staticClass: "ach-dialog-heading" }, [
      _c("div", [
        _c("span", { staticClass: "dialog-kicker" }, [
          _vm._v(_vm._s(_vm.$t("invoices.ach-account.new-account")))
        ]),
        _c("h2", [
          _vm._v(_vm._s(_vm.$t("invoices.new-ach-account.connect-account")))
        ])
      ]),
      _c(
        "button",
        {
          staticClass: "dialog-close",
          attrs: { type: "button", "aria-label": _vm.$t("global.close") },
          on: { click: _vm.handleClose }
        },
        [_c("portal-icon", { attrs: { name: "x", size: 19 } })],
        1
      )
    ]),
    _c("div", { staticClass: "connection-grid" }, [
      _c("article", { staticClass: "connection-card recommended" }, [
        _c(
          "span",
          { staticClass: "connection-icon" },
          [_c("portal-icon", { attrs: { name: "landmark", size: 25 } })],
          1
        ),
        _c(
          "div",
          [
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("invoices.new-ach-account.verification")))
            ]),
            _c(
              "portal-status-pill",
              {
                attrs: {
                  background: "var(--v-success_10-base)",
                  color: "var(--v-success-base)"
                }
              },
              [
                _c("portal-icon", { attrs: { name: "check", size: 14 } }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("invoices.new-ach-account.recommended")) +
                    " "
                )
              ],
              1
            )
          ],
          1
        ),
        _c("p", [_vm._v(_vm._s(_vm.$t("invoices.new-ach-account.use-plaid")))]),
        _c(
          "button",
          {
            staticClass: "connection-action primary",
            attrs: { type: "button" },
            on: { click: _vm.connectPlaid }
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.$t("invoices.new-ach-account.connect-plaid")) +
                " "
            ),
            _c("portal-icon", { attrs: { name: "arrow-right", size: 17 } })
          ],
          1
        )
      ]),
      _c("article", { staticClass: "connection-card" }, [
        _c(
          "span",
          { staticClass: "connection-icon" },
          [_c("portal-icon", { attrs: { name: "receipt-text", size: 25 } })],
          1
        ),
        _c("div", [
          _c("h3", [
            _vm._v(_vm._s(_vm.$t("invoices.new-ach-account.enter-info")))
          ])
        ]),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("invoices.new-ach-account.stripe-verification")))
        ]),
        _c(
          "button",
          {
            staticClass: "connection-action outline",
            attrs: { type: "button" },
            on: { click: _vm.connectManually }
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.$t("invoices.new-ach-account.connect-manually")) +
                " "
            ),
            _c("portal-icon", { attrs: { name: "arrow-right", size: 17 } })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }